import React, { useEffect, useState } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";

import { Dvr } from "@mui/icons-material";

import { OtpServices } from "../services/OtpServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { appConfigServices } from "../services/AppConfigServices";

const UserInsightsCount = () => {
  const [latestVersionCode, setLatestVersionCode] = useState("");
  const [appType, setAppType] = useState("");
  const [minVersionCode, setMinVersionCode] = useState("");
  const [latestVersionName, setLatestVersionName] = useState("");
  const [status, setStatus] = useState("");
  const [currentData, setCurrentData] = useState([]);
  const [versionCounts, setVersionCounts] = useState({
    ANDROIDAPP: {},
    DMAPP: {},
    IOSAPP: {}
  });

  useEffect(() => {
    const fetchConfigData = async () => {
      try {
        const response = await appConfigServices.getCurrentAndroidAppConfig();
        setCurrentData(response.data.appConfig);
        
        const versionRes = await OtpServices.getUsersCount();
        setVersionCounts(versionRes.data.versionCountReport);
      } catch (error) {
        handleApiErrorResponses(error);
      }
    };
    fetchConfigData();
  }, []);

  const renderVersionCounts = (appType) => {
    const counts = versionCounts && versionCounts[appType.toUpperCase()] || {};
    
    return (
      <div className="w-full">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="bg-[#F5F5F5]">
              <th className="border p-1 text-left font-semibold text-[#191919]">Version</th>
              <th className="border p-1 text-left font-semibold text-[#191919]">Count</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(counts).map(([version, count]) => (
              <tr key={version}>
                <td className="border p-1 text-[#191919]">{version}</td>
                <td className="border p-1 text-[#191919] font-semibold">{count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  return (
    <div className="w-full box-border p-[32px] mt-[92px]">
      <span className="path_line font-semibold">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Profile &nbsp; &nbsp;/ &nbsp; &nbsp; User Insights Count
      </span>
      <text className="heading">User Insights Count</text>
      <hr
        style={{ width: "100%", border: "1px solid rgba(228, 228, 228, 1)" }}
      />

      <div
        style={{ border: "1px solid #e5e5e5" }}
        className="rounded-[20px] mt-8 p-8"
      >
        {/* Table Display */}
        <div className="grid grid-cols-6 gap-12 text-[#797979] text-[18px] px-4 w-full ">
          <div className="flex flex-col">
            <div className="text-[#191919] font-semibold mb-2">App Type</div>
          </div>
          <div className="col-span-1 flex flex-col">
            <div className="text-[#191919] font-semibold mb-2">
              Latest Version Code
            </div>
          </div>
          <div className="col-span-1 flex flex-col">
            <div className="text-[#191919] font-semibold mb-2">
              Minimum Version Code
            </div>
          </div>
          <div className="col-span-1 flex flex-col">
            <div className="text-[#191919] font-semibold mb-2">
              Latest Version Name
            </div>
          </div>
          <div className="col-span-1 flex flex-col">
            <div className="text-[#191919] font-semibold mb-2">Status</div>
          </div>
          <div className="col-span-1 flex flex-col">
            <div className="text-[#191919] font-semibold mb-2">Version Counts</div>
          </div>
        </div>

        {/* Display current data in a table */}
        {currentData.map((data, index) => (
          <div
            className={`grid grid-cols-6 gap-12 text-[#797979] text-[16px] p-4 w-full ${
              index % 2 === 0 ? "bg-[#F5F5F5]" : "bg-white"
            }`}
            key={index}
          >
            <div className="flex flex-col">
              <div className="text-[#191919]">{data.appType}</div>
            </div>
            <div className="col-span-1 flex flex-col">
              <div className="text-[#191919]">{data.latestVersionCode}</div>
            </div>
            <div className="col-span-1 flex flex-col">
              <div className="text-[#191919]">{data.minVersionCode}</div>
            </div>
            <div className="col-span-1 flex flex-col">
              <div className="text-[#191919]">{data.latestVersionName}</div>
            </div>
            <div className="col-span-1 flex flex-col">
              <div className="text-[#191919]">{data.status}</div>
            </div>
            <div className="col-span-1 flex flex-col">
              <div className="text-[#191919]">
                {renderVersionCounts(data.appType)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserInsightsCount;